module.exports = __webpack_public_path__ + "img/LOVE.bb66ab51.png";